import { KbChapterPage } from "@/components/kb/KbChapterPage";

export function Chapter017() {
  return <KbChapterPage slug="chapter-017" />;
}

(Chapter017 as unknown as { path: string }).path = "/theory-album/017";
